import { FormHelperText, styled } from '@mui/material'

export const HelperText = styled(FormHelperText)(() => ({
  marginTop: '8px',
  textAlign: 'center',
}))
